/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import Snackbar from "@material-ui/core/Snackbar";
import React from "react";

const StyledSnackbar = styled(({ ...props }) => <Snackbar {...props} />)`
  && {
  }
`;

export { StyledSnackbar };
